import { Component, OnInit } from '@angular/core';
import { LogService } from './core/log.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  showDebugger = false;

  constructor(
    private _activatedRoute: ActivatedRoute,
    private gtmService: GoogleTagManagerService,
    private router: Router,
  ) {
    this.router.events.forEach((item) => {
      if (item instanceof NavigationEnd) {
        const gtmTag = {
          event: 'page',
          pageName: item.url,
        };
        this.gtmService.pushTag(gtmTag);
      }
    });
  }

  ngOnInit(): void {
    this._activatedRoute.queryParams.subscribe((params) => {
      this.showDebugger = params['debugger'] === 'true';
    });
  }
}
